var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Responsive',{attrs:{"breakpoints":{
    small: function (el) { return el.width <= 650; },
    medium: function (el) { return el.width <= 800; },
  }},scopedSlots:_vm._u([{key:"default",fn:function(el){return _c('div',{class:[
      'Abt-main-panel',
      { AboutMeSmall: el.is.small, AboutMeMedium: el.is.medium } ]},[_c('div',{staticClass:"title-and-description"},[_c('h1',{staticClass:"Abt-main-title"},[_vm._v("About Me")]),_c('p',{staticClass:"Abt-description",domProps:{"innerHTML":_vm._s(_vm.data.mainText)}})]),_c('div',{staticClass:"Abt-image",style:({
        'background-image':
          'linear-gradient(0deg,rgba(22, 32, 48, 1) 0%,rgba(25, 34, 58, 0.8029586834733894) 18%,rgba(105, 110, 126, 0) 43%,rgba(255, 255, 255, 0) 100%), url(' +
          _vm.data.imageUrl +
          ')',
      })},[_c('small',{staticClass:"Abt-img-caption"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.data.imageCaption)}})])])])}}])})}
var staticRenderFns = []

export { render, staticRenderFns }